<template>
	<button
		type="button"
		:disabled="disabled"
		:class="{
    'whitespace-nowrap': !wrap,
    'bg-primary text-primary-letter focus:bg-primary-touch hover:bg-primary-touch active:bg-primary-press focus:ring-qwr-haze-100': variant === 'primary',
    'bg-secondary text-secondary-letter focus:bg-secondary-touch hover:bg-secondary-touch active:bg-secondary-press focus:ring-qwr-haze-100': variant === 'secondary',
    'bg-white  focus:ring-qwr-haze-100': variant === 'light',
    'border-qwr-haze-200 text-qwr-dark hover:border-qwr-haze-300 active:bg-qwr-haze-50': variant === 'light' && !active,
    'border-primary text-primary': variant === 'light' && active,
    'pointer-events-none opacity-50': disabled,
  }"
		class="border rounded-full px-6 py-2 text-sm font-medium uppercase tracking-[1px] focus:outline-hidden focus:ring-3 select-none"
	>
		<slot />
	</button>
</template>

<script lang="ts" setup>
export interface Props {
  variant?: 'primary' | 'secondary' | 'light'
  active?: boolean
  disabled?: boolean
  wrap?: boolean
}

withDefaults(defineProps<Props>(), {
  variant: 'primary',
  active: false,
  disabled: false,
  wrap: false,
});
</script>
